import { LikeItemActionHorizontal, SecondIcon, ThirdIcon } from './styles';
import { Icon } from '../item/styles';

const LikeButton = ({
  level,
  disabled,
  onClick,
}) => {
  return (
    <LikeItemActionHorizontal disabled={disabled} onClick={onClick} isActive={level >= 1}>
      <span>{level >= 1 ? 'Like more!' : 'Like'}</span>
      {
        level === 0 ? (
          <Icon className="icon-like" />
        ) : (
          <>
            <Icon className="icon-like-filled" />
            {level > 1 ? (<SecondIcon className="icon-like-filled" />) : null}
            {level > 2 ? (<ThirdIcon className="icon-like-filled" />) : null}
          </>
        )
      }
    </LikeItemActionHorizontal>
  );
};

export default LikeButton;
